<m-message-page class="m-error-technical-difficulty"
                  :state="state"
                  :svg-name="svgName"
                  :title="title"
                  :hints="hints"
                  :links="links">
    <m-accordion skin="light"
                 icon-size="small">
        <m-i18n slot="header" k="m-error-technical-difficulty:details"></m-i18n>
        <p class="m-error-technical-difficulty__browser"><strong>{{'m-error-technical-difficulty:browser' | f-m-i18n}}: </strong>{{userAgent}}</p>
        <p v-if="!!errorReferenceNumber"><strong>{{'m-error-technical-difficulty:reference-number' | f-m-i18n}}: </strong>{{errorReferenceNumber}}</p>
        <p>
            {{'m-error-technical-difficulty:date.primary' | f-m-i18n}}
            <strong>{{formattedDate}}</strong>
            {{'m-error-technical-difficulty:date.secondary' | f-m-i18n}}
            <strong>{{formattedTime}}</strong>
        </p>
        <m-panel  class="m-error-technical-difficulty__stacktrace" :padding="false" v-if="propStacktrace">
            <pre>{{error.stack}}</pre>
        </m-panel>
    </m-accordion>
</m-message-page>
